"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [0, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _this = this;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var configuration = {};
exports.url = function (endpoint, params) {
  var urlParams = __assign({
    app: 'widget',
    apiKey: configuration['apiKey']
  }, params);
  var queryString = Object.keys(urlParams).map(function (key) {
    return key.toLowerCase() + "=" + urlParams[key];
  }).join('&');
  return constants_1.THS_API.URL + "/" + endpoint + "?" + queryString;
};
exports.setApiKey = function (apiKey) {
  return configuration['apiKey'] = apiKey;
};
exports.fetchScores = function (apiParams, customizations) {
  return __awaiter(_this, void 0, void 0, function () {
    var thsResponse, totalHomeScores;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetch(exports.url(constants_1.THS_API.REPORTS, apiParams))];
        case 1:
          thsResponse = _a.sent();
          return [4, thsResponse.json()];
        case 2:
          totalHomeScores = _a.sent().totalHomeScores;
          exports.setApiKey(apiParams.apiKey);
          utils_1.setUser(thsResponse.headers.get('x-vcap-request-id') || '');
          return [2, Object.keys(totalHomeScores).sort(function (a, b) {
            return Object.keys(utils_1.SupportScores).indexOf(a) - Object.keys(utils_1.SupportScores).indexOf(b);
          }).map(utils_1.transformScore(totalHomeScores, customizations))];
      }
    });
  });
};
exports.sendEvent = function (events) {
  return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetch(exports.url(constants_1.THS_API.ANALYTICS), {
        body: JSON.stringify({
          events: events
        }),
        headers: {
          'content-type': 'application/json'
        },
        redirect: 'follow',
        referrer: 'client',
        referrerPolicy: 'origin-when-cross-origin',
        method: 'POST',
        mode: 'cors'
      })];
    });
  });
};